import {
  getVisibleSuperTabs,
  flattenSuperTabs,
  getSuperTabsEntries,
} from './helpers';
import comparator from '../../commonComparators/caseInsensitive';
import { createNavigationEntry } from './helpers';

const cleanseAddonsSubtabs = (superTabs) => {
  return superTabs.map((superTab) =>
    superTab.nameKey !== 'ADD_ONS'
      ? superTab
      : { ...superTab, sectionTabs: [] },
  );
};

/**
 * @type {CommandPalettePlugin}
 */
export const navigationPlugin = {
  visExp: 'true',
  id: 'navigationPlugin',
  getResults: async ({ tabs }) => {
    const visibleSuperTabs = cleanseAddonsSubtabs(
      getVisibleSuperTabs(tabs.superTabs),
    );

    const flattenedSuperTabs = flattenSuperTabs(visibleSuperTabs);
    const superTabsEntries = getSuperTabsEntries(visibleSuperTabs);

    return (searchString) =>
      new Promise((resolve) => {
        const filterNavigationEntries = () => {
          if (!searchString || searchString.trim().length === 0) {
            return superTabsEntries.map((superTab) =>
              createNavigationEntry({ superTab }),
            );
          }

          return flattenedSuperTabs
            .map((entry) => createNavigationEntry(entry, searchString.trim()))
            .filter((superTab) =>
              comparator(superTab.searchLabel, searchString),
            );
        };

        resolve(filterNavigationEntries());
      });
  },
};
